import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const ShareIcon: FunctionComponent<Props> = ({
  className = "",
  width = 14,
  height = 12,
  fill = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Share</title>
      <path
        fill={fill}
        stroke={fill}
        strokeLinejoin="round"
        d="M8.857 1.125V3.68S2.5 3 .5 9.714v1.161c1.632-3.482 6.275-3.482 8.357-2.786v2.322L13.5 5.768 8.857 1.125Z"
      />
    </svg>
  );
};

export default ShareIcon;
